import { createLucideIcon } from 'lucide-react'

 
const ListFilterPlus = createLucideIcon('ListFilterPlus', [
  ['path', { d: 'M12 5H2', key: 'filter-top' }],
  ['path', { d: 'M6 12h12', key: 'filter-middle' }],
  ['path', { d: 'M9 19h6', key: 'filter-bottom' }],
  ['path', { d: 'M16 5h6', key: 'plus-horizontal' }],
  ['path', { d: 'M19 8V2', key: 'plus-vertical' }],
])

export default ListFilterPlus
